<template>
      <div class="main-area py-4">
        <div class="md:py-6  p-5 form-design-color" id="alert_image_overlay">
            <div class="login-banner pt-8 md:pt-0 flex items-center justify-center">
                Welcome back!
            </div>
            <div class="login-header pt-4 text-center">
                Sign In to BuyHive 
                <br/>
                as a 
                <span v-if="LoginSelectionMode == 'buyer'" >Buyer</span>
                <span v-else >Sourcing Expert</span>
            </div>
            <div class="md:pt-6 md:pb-0 p-5 md:px-28">
            <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
              <form class="md:px-10" @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider v-slot="{ errors }" rules="required|email">
                  <input
                    class="form-input"
                    type="text"
                    placeholder="E-mail Address"
                    name="Email"
                    v-model="formData.login"
                  >
                  <div class="input-error pb-9">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <input
                    class="form-input"
                    type="password"
                    name="Password"
                    placeholder="Password"
                    v-model="formData.password"
                  >
                  <div class="input-error">{{ errors[0] }}</div>
                </ValidationProvider>
                <div>
                  <div
                    class="inline-flex items-center cursor-pointer"
                    @click="rememberMe = !rememberMe">
                    <input
                      type="checkbox"
                      value="true"
                      v-model="rememberMe"
                      class="w-4 h-4">
                    <span class="pl-4 opacity-50">Keep me Signed In</span>
                  </div>
                </div>
              <div class="flexbox text-center pt-2 md:pt-6">
                  <button class="new-app-btn bg-blue mt-6 sm:mt-0 font-semibold ">
                    Sign In
                  </button>
                  <br>
                  <p v-if="LoginSelectionMode == 'buyer'" class="font-normal pt-2 pb-2">or
                  </p>
                  <button v-if="LoginSelectionMode == 'buyer'" class="new-app-btn bg-green font-semibold pt-8"
                    @click="authenticate"
                    type="button">
                    Sign In with LinkedIn
                  </button>
                </div>
            </form>
            </ValidationObserver>
              <div class="pt-4 md:pt-6 text-center font-semibold md:text-xl tracking-tighter">
                Don’t have an account?
                <a v-if="LoginSelectionMode == 'buyer'"
                  @click="redirectToRegister"
                  class="text-blue underline cursor-pointer font-semibold"
                >
                  Create one!
                </a>
                <a v-else 
                  :href="freelancer_registration_link"
                  class="text-blue underline font-semibold">
                  Create one!
                </a>
                <br>
                <span class="forgot-password md:text-lg font-normal tracking-tighter">
                  Forgot password?
                  <button @click="openForgetPassword()" class="text-green underline">
                    Click here to create new one.
                  </button>
                </span>
              </div>
            </div>
        </div>
        </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  name: 'Alert',
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Sign In | The BuyHive',
    next()
  },
  data() {
    return {
      formData: {
        login: '',
        password: ''
      },
      isFreelancer: false,
      rememberMe: false,
      baseURL: process.env.VUE_APP_SERVER_BASE_URL,
      freelancerURL:  process.env.VUE_APP_FREELANCER_HOME_PATH,
      buyer_registration_link: `${process.env.VUE_APP_BUYER_HOME_PATH}/register`,
      freelancer_registration_link: `${process.env.VUE_APP_FREELANCER_HOME_PATH}/register`,
    }
  },
  computed: {
    ...mapGetters ([ 'LoginSelectionMode', 'isUserLoggedIn', 'isForgetPasswordModalOpen' ]),
  },
  beforeDestroy() {
      localStorage.removeItem('previousUrl');
      localStorage.removeItem('existingSourcingToken')
      localStorage.removeItem('activeTab')
      this.openLoginModal(false)
  },
  BeforeRouteLeave() {
      localStorage.removeItem('previousUrl');
      localStorage.removeItem('existingSourcingToken')
      localStorage.removeItem('activeTab')
      this.openLoginModal(false)
  },
  methods: {
    ...mapActions ([ 'openLoginModal', 'login', 'loginWithLinkedIn', 'openForgetPasswordModal' ]),
    async onSubmit() {
      const response = await this.login({
        formData: this.formData,
        rememberMe: this.rememberMe
      })
      if (response.result && this.isUserLoggedIn) {
        if(response.role == 'freelancer') {
          localStorage.removeItem('previousUrl')
          localStorage.removeItem('existingSourcingToken')
          window.location = '/expertsourcing/email-verification'
        }
        else if(this.$route.query.redirect_url) {
          window.location = this.$route.query.redirect_url
        }
        else if(this.$route.query.prev == '/checkout') {
          window.location = `${process.env.VUE_APP_BUYER_HOME_PATH}/checkout`
        }
        else if(localStorage.getItem('previousUrl') && localStorage.getItem('supplierCriteriaDetails') && localStorage. getItem('existingSourcingToken')) 
        {
          let sourcing_token = localStorage.getItem('existingSourcingToken')
          this.$store.commit('setSourcingRequestToken',sourcing_token)
          localStorage.removeItem('previousUrl')
          localStorage.removeItem('existingSourcingToken')
          this.$router.push({ name: 'Sourcing Request', query: { editing: true }})
        }
        else if (this.$route.query.prev && !localStorage.getItem('previousUrl')) 
        {
          localStorage.removeItem('previousUrl')
          this.$router.push(`${this.$route.query.prev}`)
        } 
        else if (localStorage.getItem('previousUrl')) 
        {
          let previous_url = localStorage.getItem('previousUrl')
          localStorage.removeItem('previousUrl')
          window.location = previous_url
        } 
        else {
          this.$router.push({name: 'Home'})
        }
        localStorage.removeItem('previousUrl')
      } else {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: response.message
        });
      }
    },
    redirectToRegister() {
      if(this.$route.query.prev == '/checkout') {
        this.$router.push({name: 'Register', query: {prev : '/checkout'}})
      }else {
        window.location = this.buyer_registration_link
      }
    },
    async authenticate() {
      if(localStorage.getItem('previousUrl') == null ) {
        if(this.$route.query.prev == '/checkout') {
          localStorage.setItem('previousUrl', `${process.env.VUE_APP_BUYER_HOME_PATH}/checkout`)
        } else if(this.$route.query.redirect_url) {
          localStorage.setItem('previousUrl', this.$route.query.redirect_url)
        } else {
          localStorage.setItem('previousUrl', window.location.href)
        }
      }

      this.openLoginModal(false)
      const response = await this.loginWithLinkedIn()
      if(response.result) window.location.href = response.url;
    },
    openForgetPassword() {
      this.openLoginModal(false)
      this.openForgetPasswordModal(true)
    }
  }
}
</script>

<style lang="scss" scoped>
// .main-area {
//   // background: linear-gradient(180deg, #DCFBFF 0%, #F9FFF0 100%);
// }
  .alert-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          content: "";
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
#close-btn {
  position: relative;
}
#alert_image_overlay {
  margin: 1em auto;
  width: 40%;

  @media (max-width: 768px) {
    width: 85%;
  }
}
.form-design-color{
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}

.new-app-btn {
  @media(min-width: 768px) {
    font-weight: 700 !important;
    font-size: 20px !important;
  }
  @apply rounded-full px-8 text-lg py-2 text-white;
}

.login-header {
    color: #00B2C9;
    font-size: 28px;
    line-height: 38.25px;
    font-weight: 600;
}
.login-banner {
  font-weight:500;
  font-size: 20px;
  line-height: 27.32px;
}
.forgot-password {
  @media (min-width: 768px) {

   font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  }
}
</style>